import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import HowItWorks from "@/components/sections/HowItWorks";
import AuditWizard from "@/components/sections/AuditWizard";
import Testimonials from "@/components/sections/Testimonials";
import Founder from "@/components/sections/Founder";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative overflow-x-hidden">
      <Nav />
      <Hero />
      <HowItWorks />
      <AuditWizard />
      <Testimonials />
      <Founder />
      <FAQ />
      <Footer />
    </div>
  );
}
